export enum GenderChar {
  Male = 'M',
  Female = 'F',
}
